import { ZUid } from "src/types/zUid";
import { ZMCPoint } from "../../../ZMeasurementChart";

export type McSize = {
  id: ZUid;
  name: string;
  versions: Record<ZUid, string>;
};

export const makeSizesFromPoints = (rows: ZMCPoint[]): McSize[] => {
  const dict: Record<ZUid, McSize> = {};
  const getItem = (id: ZUid, name: string): McSize => {
    const oldItem = dict[id];
    if (oldItem) return oldItem;
    const newItem: McSize = { id, name, versions: {} };
    dict[id] = newItem;
    return newItem;
  };
  rows.forEach(({ sizes }) => {
    sizes.forEach(({ id, name, pointValues }) => {
      const item: McSize = getItem(id, name);
      pointValues.forEach(({ version }) => {
        item.versions[version.id] = version.name;
      });
    });
  });
  return Object.values(dict);
};

export const getVersionValueFromRow = (
  row: ZMCPoint,
  sizeId: ZUid,
  verId: ZUid,
): string => {
  const size = row.sizes.find(({ id }) => id === sizeId);
  const ver = size?.pointValues.find(({ version }) => version.id === verId);
  return String(ver?.value ?? "");
};
